import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";

import "swiper/css";

const slidersImages = document.querySelectorAll(".images-slider");
const slidersBlogs = document.querySelectorAll(".blogs-slider");
const slidersTextMedia = document.querySelectorAll(".text-media-slider");
const slidersHero = document.querySelectorAll(".hero-slider");
const slidersTimeline = document.querySelectorAll(".timeline-slider");
const slidersReviews = document.querySelectorAll(".reviews-slider");

// Mobile only: give every hero text card the height of the tallest one so the
// image below always starts at the same position. Cleared at lg+ (text overlays
// the image there). Re-measures on resize and includes Swiper's loop clones.
const equalizeHeroText = (el) => {
    const cards = el.querySelectorAll(".hero-text");
    cards.forEach((c) => { c.style.minHeight = ""; });
    if (window.innerWidth >= 1024) return;
    let max = 0;
    cards.forEach((c) => { max = Math.max(max, c.offsetHeight); });
    if (max) cards.forEach((c) => { c.style.minHeight = `${max}px`; });
};

document.addEventListener("DOMContentLoaded", () => {
    slidersHero.forEach((el) => {
        const swiperEL = el.querySelector(".swiper");
        const paginationEl = el.querySelector(".swiper-pagination");
        new Swiper(swiperEL, {
            modules: [Pagination, Autoplay],
            speed: 800,
            slidesPerView: 1,
            loop: el.querySelectorAll(".swiper-slide").length > 1,
            autoplay: { delay: 5000, disableOnInteraction: false },
            pagination: paginationEl ? { el: paginationEl, clickable: true } : undefined,
        });
        equalizeHeroText(el);
    });

    let heroResizeTimer;
    window.addEventListener("resize", () => {
        clearTimeout(heroResizeTimer);
        heroResizeTimer = setTimeout(() => slidersHero.forEach(equalizeHeroText), 150);
    });

    if (slidersImages) {
        slidersImages.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined;
            // data-centered → 3 full slides + a half-peek each side, centered
            const centered = el.hasAttribute("data-centered");
            const slideTotal = el.querySelectorAll(".swiper-slide").length;
            // Only loop when there are more slides than fit the widest breakpoint (4).
            // Otherwise loop duplicates fill & overflow the track, breaking centering.
            const canLoop = slideTotal > 4;
            const swiper = new Swiper(swiperEL, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: centered ? 12 : 10,
                slidesPerView: 1,
                watchOverflow: true,
                centeredSlides: centered,
                loop: canLoop,
                // start in the middle so both side-peeks show on first paint
                initialSlide: centered ? Math.floor(slideTotal / 2) : 0,
                navigation,
                pagination,
                breakpoints: {
                    480: {
                        slidesPerView: centered ? 3 : 2,
                        spaceBetween: centered ? 16 : 10,
                    },
                    768: {
                        slidesPerView: centered ? 3 : 3,
                        spaceBetween: centered ? 24 : 10,
                    },
                    // Desktop. centeredSlides (data-centered → withBgColor) uses an
                    // ODD count so there is a single true middle slide (5 in view →
                    // the 3rd is centered/active at full opacity). Without it, 4
                    // full (bigger) logos with a 10px gap.
                    1024: {
                        slidesPerView: centered ? 5 : 4,
                        spaceBetween: centered ? 32 : 10,
                    },
                },
            });
        });
    }

    if (slidersBlogs) {
        slidersBlogs.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl ? { el: paginationEl, clickable: true } : undefined;

            new Swiper(swiperEL, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: 16,
                slidesPerView: 1,
                watchOverflow: true,
                navigation,
                pagination,
                breakpoints: {
                    720: { slidesPerView: 2, spaceBetween: 24 },
                    1024: { slidesPerView: 3, spaceBetween: 32 },
                },
            });
        });
    }

    if (slidersTextMedia) {
        slidersTextMedia.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");
            const paginationEl = el.querySelector(".swiper-pagination");

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;
            const pagination = paginationEl
                ? { el: paginationEl, clickable: true }
                : undefined;
            const swiper = new Swiper(swiperEL, {
                modules: [Navigation, Pagination],
                speed: 400,
                spaceBetween: 12,
                slidesPerView: 1,
                watchOverflow: true,
                navigation,
                pagination,
                breakpoints: {
                    480: {
                        slidesPerView: 1.5,
                        spaceBetween: 16,
                    },
                    720: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                    },
                    1440: {
                        slidesPerView: 5,
                        spaceBetween: 32,
                    },
                },
            });
        });
    }

    if (slidersTimeline) {
        slidersTimeline.forEach((el) => {
            const swiperEL = el.querySelector(".swiper");
            // nav buttons sit in the block header, outside .timeline-slider
            const scope = el.closest("section") || el;
            const nextEl = scope.querySelector(".timeline-next");
            const prevEl = scope.querySelector(".timeline-prev");
            const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;
            new Swiper(swiperEL, {
                modules: [Navigation],
                speed: 500,
                slidesPerView: 1.2,
                spaceBetween: 0,
                watchOverflow: true,
                navigation,
                breakpoints: {
                    640: { slidesPerView: 2 },
                    1024: { slidesPerView: 3 },
                    1280: { slidesPerView: 4 },
                },
            });
        });
    }

    if (slidersReviews) {
        slidersReviews.forEach((el) => {
            const mainEl = el.querySelector(".reviews-main");
            if (!mainEl) return;
            const thumbsEl = el.querySelector(".reviews-thumbs .swiper");
            const nextEl = el.querySelector(".swiper-button-next");
            const prevEl = el.querySelector(".swiper-button-prev");

            // logo strip: a swiper that glides (translateX) to centre the active logo
            const reviewCount = parseInt(el.dataset.reviewCount, 10) || 0;

            const thumbs = thumbsEl
                ? new Swiper(thumbsEl, {
                      slidesPerView: "auto",
                      centeredSlides: true,
                      spaceBetween: 24,
                      loop: true,
                      watchSlidesProgress: true,
                  })
                : null;

            // The logo strip glides one logo per review change. Track the previous review and
            // move by the loop-shortest delta with slideTo — a real translate every time, so it
            // always scrolls; loop:true + the 3x copies keep it from dead-ending. Highlight =
            // Swiper's own `.swiper-slide-active` (the centred logo).
            let prevReal = 0;
            const alignThumbs = (target) => {
                if (!thumbs || !reviewCount) return;
                let d = target - prevReal;
                if (d > reviewCount / 2) d -= reviewCount;
                if (d < -reviewCount / 2) d += reviewCount;
                prevReal = target;
                if (d !== 0) thumbs.slideTo(thumbs.activeIndex + d);
            };

            // give every quote slide the height of the tallest one
            const equalizeMain = () => {
                const slides = [...mainEl.querySelectorAll(".swiper-slide")];
                if (!slides.length) return;
                slides.forEach((s) => (s.style.height = "auto"));
                const max = Math.max(...slides.map((s) => s.offsetHeight));
                slides.forEach((s) => (s.style.height = max + "px"));
            };

            const navigation = nextEl && prevEl ? { nextEl, prevEl, addIcons: false } : undefined;

            const main = new Swiper(mainEl, {
                modules: [Navigation],
                speed: 400,
                spaceBetween: 32,
                slidesPerView: 1,
                loop: true,
                navigation,
                on: {
                    afterInit: (sw) => {
                        equalizeMain();
                        prevReal = sw.realIndex;
                        // align: shift the strip so the centred logo matches the current review
                        if (thumbs && reviewCount) {
                            const cur = parseInt(thumbs.slides[thumbs.activeIndex]?.querySelector(".reviews-thumb")?.dataset.reviewIndex, 10) || 0;
                            let d = sw.realIndex - cur;
                            if (d > reviewCount / 2) d -= reviewCount;
                            if (d < -reviewCount / 2) d += reviewCount;
                            if (d !== 0) thumbs.slideTo(thumbs.activeIndex + d, 0);
                        }
                    },
                    resize: () => equalizeMain(),
                    slideChange: (sw) => alignThumbs(sw.realIndex),
                },
            });
            // recompute once webfonts settle (text reflow can change heights)
            if (document.fonts && document.fonts.ready) document.fonts.ready.then(equalizeMain);

            // clicking a logo glides the main slider to that review
            if (thumbsEl) {
                thumbsEl.querySelectorAll(".reviews-thumb").forEach((btn) => {
                    btn.addEventListener("click", () => {
                        const i = parseInt(btn.dataset.reviewIndex, 10);
                        if (!Number.isNaN(i)) main.slideToLoop(i);
                    });
                });
            }
        });
    }
});

/* admin2win sliders — one init, config picked from [data-slider] */
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll("[data-slider]").forEach((el) => {
        const type = el.dataset.slider;
        const swiperEl = el.querySelector(".swiper");
        if (!swiperEl) return;

        const nextEl = el.querySelector(".swiper-button-next");
        const prevEl = el.querySelector(".swiper-button-prev");
        const navigation = nextEl && prevEl ? { nextEl, prevEl } : undefined;

        // try/catch so one slider's failure can never abort init of the others
        try {
            // "iconen" is no longer a Swiper — it's a scroll-pinned column handled
            // in components/scrollPin.js ([data-scroll-pin]).

            const perView = {
                testimonials: { base: 1.15, md: 2.4, lg: 3.2, xl: 4.2, xxl: 4.2 },
                // 2 full cards inside the ~2/3-width wrapper; loop fills the side
                // gutters with half-card peeks. (loop needs slides >= 2*2 = 4.)
                textMedia: { base: 1.2, md: 2, lg: 2, xl: 2, xxl: 3  },
            }[type] || { base: 1.1, md: 2.2, lg: 3, xl: 3.3 };

            const isTextMedia = type === "textMedia";

            // Give every text-media card the height of the tallest one (varying text
            // lengths otherwise make each card a different height). Includes Swiper's
            // loop clones; re-measures on resize/breakpoint change + fonts load.
            const equalize = () => {
                const slides = [...swiperEl.querySelectorAll(".swiper-slide")];
                if (!slides.length) return;
                slides.forEach((s) => (s.style.height = "auto"));
                const max = Math.max(...slides.map((s) => s.offsetHeight));
                if (max) slides.forEach((s) => (s.style.height = `${max}px`));
            };

            new Swiper(swiperEl, {
                modules: [Navigation],
                speed: 500,
                spaceBetween: 32,
                watchOverflow: true,
                navigation,
                slidesPerView: perView.base,
                // text-media loops so the side gutters always show half-card peeks.
                loop: isTextMedia && el.querySelectorAll(".swiper-slide").length > 1,
                // Keep slides rendered in BOTH gutters (otherwise the left peek
                // is empty since the active slide sits flush to the left edge).
                loopAdditionalSlides: isTextMedia ? 2 : 0,
                // Start on the 2nd slide so a real previous slide is positioned to
                // its left at init → the left half-peek shows on first paint
                // (Swiper only fills the very-first slide's left on slide change).
                initialSlide: isTextMedia ? 1 : 0,
                breakpoints: {
                    720: { slidesPerView: perView.md },
                    1024: { slidesPerView: perView.lg },
                    1440: { slidesPerView: perView.xl },
                    1600: { slidesPerView: perView.xxl }
                },
                on: isTextMedia ? {
                    afterInit: equalize,
                    resize: equalize,
                    imagesReady: equalize,
                } : {},
            });

            if (isTextMedia && document.fonts && document.fonts.ready) {
                document.fonts.ready.then(equalize);
            }
        } catch (e) {
            console.error("Slider init failed for", type, e);
        }
    });
});
